(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const overlay = document.getElementById('ll-popup-overlay');
  const closeBtn = document.getElementById('ll-popup-close');

  // Only show popup if not shown this session
  if (!sessionStorage.getItem('ll_popup_shown')) {
    setTimeout(function() {
      if (!overlay) return;
      overlay.style.display = 'block';
      sessionStorage.setItem('ll_popup_shown', 'true');
    }, 3000); // delay in ms
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      overlay.style.display = 'none';
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        overlay.style.display = 'none';
      }
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
